import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { ChangeStudentStatusForGroupPayload } from "../../payload/ChangeStudentStatusForGroup/ChangeStudentStatusForGroupPayload";

const changeStudentStatusForGroupFetch = (state: GroupsState, action: PayloadAction<ChangeStudentStatusForGroupPayload>) => {
    state.isLoading = true;
}

export default changeStudentStatusForGroupFetch;